export const getCoonawarraData = () => ({
  name: "Coonawarra",
  country: "Australie",
  description: "Coonawarra est une région viticole prestigieuse d'Australie-Méridionale, célèbre pour ses sols terra rossa et ses Cabernet Sauvignon de classe mondiale. Son climat frais et ses sols calcaires créent des conditions idéales pour des vins rouges de grande finesse.",
  type: "region",
  mapAreas: [
    { region: "Coonawarra", x: 38, y: 85, color: "#e2c2e2", size: 3 }
  ],
  statistics: {
    totalArea: "3,500 ha",
    production: "0.2 million hectolitres",
    appellations: "Coonawarra GI",
    subregions: "2 sous-régions principales",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat frais avec étés chauds et secs, hivers froids, influence océanique",
    soil: "Sols terra rossa (argile rouge sur calcaire), excellente drainage",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Cabernet Sauvignon de classe mondiale, Shiraz élégants, assemblages complexes",
    white: "Chardonnay frais et aromatiques, Sauvignon Blanc élégants, Riesling complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Coonawarra remonte aux années 1890. La région s'est imposée comme l'une des plus prestigieuses d'Australie, reconnue pour ses Cabernet Sauvignon de classe mondiale et ses sols terra rossa uniques.",
  foodPairing: "Cuisine australienne : viandes rouges, gibier, fromages affinés, cuisine gastronomique.",
  subregions: {
    "coonawarra": {
      name: "Coonawarra",
      description: "Cœur de la région, réputé pour ses Cabernet Sauvignon de classe mondiale et ses sols terra rossa.",
      characteristics: {
        climate: "Frais, influence océanique",
        soil: "Sols terra rossa (argile rouge sur calcaire)",
        viticulture: "Vignobles historiques, rendements limités"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Cabernet Sauvignon", "Shiraz", "Merlot"]
      },
      wineStyles: {
        "cabernet-sauvignon": "Rouges de classe mondiale, vieillissement exceptionnel",
        "shiraz": "Rouges élégants et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "penola": {
      name: "Penola",
      description: "Zone méridionale, connue pour ses vins rouges structurés et ses blancs frais.",
      characteristics: {
        climate: "Frais, influence océanique",
        soil: "Sols terra rossa et argileux",
        viticulture: "Vignobles modernes, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Cabernet Sauvignon", "Shiraz", "Merlot"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et complexes",
        "blanc": "Blancs frais et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    }
  }
}); 